import React from "react";

import { Box, Button, Container, Typography } from "@mui/material";

const ContactCard = ({ buttonHref, buttonLabel, children, ...props }) => (
  <Box
    sx={{
      backgroundImage:
        "url(/static/cards/contact-card/character.png), url(/static/cards/contact-card/bg.png), linear-gradient(#fecb9e,#f0b5d7)",
      backgroundPosition: "bottom, center, center",
      backgroundRepeat: "no-repeat, repeat-x, repeat-x",
      backgroundSize: "auto 100%, auto 100%, cover",
      ...props?.sx,
    }}
    {...props}
  >
    <Container maxWidth="md" sx={{ px: { xs: 0, sm: 2 } }}>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box sx={{ width: { xs: "60%", md: "50%" } }}>
          <Box
            sx={{
              ml: { xs: 2, sm: 8, md: 16 },
              mr: { xs: 2, sm: 4 },
              my: { xs: 4, sm: 8 },
            }}
          >
            <Box
              sx={{
                backgroundColor: "#ffffff",
                px: { xs: 2, sm: 4 },
                py: 2,
                mb: 2,
                minHeight: "120px",
                border: "1px #e2dfb8 solid",
                position: "relative",
                borderRadius: "4px",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  height: 0,
                  width: 0,
                  borderRight: "30px solid transparent",
                  borderBottom: "16px solid #ffffff",
                  right: "-28px",
                  bottom: "25%",
                },
              }}
            >
              <Typography variant="h6">{children}</Typography>
            </Box>
            <Button
              href={buttonHref}
              disableElevation
              color="action"
              size="large"
              variant="contained"
              fullWidth
              sx={{ maxWidth: "200px" }}
            >
              {buttonLabel}
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  </Box>
);

export default ContactCard;
